import React from "react";

const LendTop = () => {
  return (
    <div className="lendHeading">
      <h1>You can help a family fundraise for a better life. Make a loan.</h1>
      <p>
        Select a loan you feel the most for, based on the cause, geography or
        the fundraising need.
      </p>
    </div>
  );
};

export default LendTop;
